import { Operator } from '@/widget/domain/operator';
import { Message } from '@/widget/domain/message';

export type Conversation = {
  avatarUrl: string;
  date: string;
  key: string;
  operators: Operator[],
  lastMessage?: Message;
}

export function findByKey(conversations: Conversation[] | null, key: string): Conversation {
  return conversations && conversations.find((conversation) => conversation.key === key);
}
